import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { useHistory } from "react-router-dom";
import "./style.scss";
import LineWithDot from "../../../../../assets/images/Line wit Dot.svg";
import iconTooltip from "../../../../../assets/svg/dashboard/iconTooltip.svg";
import excelButton from "../../../../../assets/images/maargThemeXls2.png";
import AnimeList from "../../StartupDashboard/ViewAllMentorList/AnimeList";
import Pagination from "react-js-pagination";
import { Button as MaterialButton } from "@material-ui/core";
import hashImage from "../../../../../assets/images/hashImage.jpeg";
import { Country, State, City } from "country-state-city";
import ChatBoxModal from "../../../../common/chatBoxModal";
import profile from "../../../../../assets/svg/dashboard/profile-iconRound.svg";
// import mentorIcon from "./img/Icon_Mentor_White.svg";
import mentorIcon from "../../../../../assets/images/Icon_Mentor_White.svg";
import mentorMiniIcon from "../../../../../assets/svg/mentorsMiniCircle.svg";
import { getStepperTooltipData } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import buttonSendMessage from "../../../../../assets/images/Icon_Chat_Message.svg";
import {
  getActivitySummaryPerformance,
  getActivitySummaryMentorshipStatus,
} from "../AdminMentorAction/dependencies/action";
import {
  GET_ACTIVITY_SUMMARY_MENTOR_DATA,
  ALL_MENTORSHIPS_ADMIN,
  GET_NAMES_DATA,
  DOWNLOAD_EXCEL_MENTORSHIP_NO_SESSION
} from "../../../../common/constants/ApplicationUrl";
import api from "../../../../common/dependencies/utils/Api";

import axios from "axios";
import mentorshipIcon2 from "../../../../../assets/svg/dashboard/view-Mentroships.svg";

// import {
//   getStartupApplication,
//   getCountersStartUpList,
// } from "../dependencies/action";
import { getPredefineOptionsList } from "../AdminMentorAction/dependencies/action";
import * as moment from "moment";
import Modal from "../../StartupDashboard/MyRequests/Modal/modal";
// import Modal from "../AllMentorships/Modal/modal";
// import Modal from "../MyRequests/Modal/modal";
import Select from "react-select";
import Button from "../Button";
import { getNamesList } from "../AdminMentorAction/dependencies/action";
import * as CryptoJS from "crypto-js";
import { PROFILE_KEY } from "../../../../common/constants/actionConstants";
const MentorshipClosed = (props) => {
  class AesUtil {
    constructor(keySize, iterationCount) {
      this.keySize = keySize / 32;
      this.iterationCount = iterationCount;
    }
  
    generateKey = function (salt, passPhrase) {
      let key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
        keySize: this.keySize,
        iterations: this.iterationCount,
      });
      return key;
    };
  
    encrypt = function (salt, iv, passPhrase, plainText) {
      let key = this.generateKey(salt, passPhrase);
      let encrypted = CryptoJS.AES.encrypt(plainText, key, {
        iv: CryptoJS.enc.Hex.parse(iv),
      });
      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    };
  }
  const encryptAES2 = (text, key) => {
    // let iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    // let salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
  
    // let aesUtil = new AesUtil(128, 1000);
    // let ciphertext = aesUtil.encrypt(salt, iv, key, text);
  
    // let aesText = iv + "::" + salt + "::" + ciphertext;
    
    return btoa(text);
  };
  const html = document.getElementsByTagName("html")[0];
  const {
    getNamesList,
    getNamesListData,
    getActivitySummaryPerformance,
    getActivitySummaryMentorshipStatus,
    getTablePaginate,
    getTableData,
    getStepperTooltipData,
    getStepperData,
  } = props;
  // const imageUrl = "https://uat-nmp-api.startupindia.gov.in/v1/document/;";
  const [Heading, setHeading] = useState();
  const [InstructionswithRole, setInstructionswithRole] = useState();
  const [SelectPage, setSelectPage] = useState();
  const [activeText, setActiveText] = useState(false);
  const [activeText2, setActiveText2] = useState(false);
  const [activeText3, setActiveText3] = useState(false);
  const [activeText4, setActiveText4] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [selectedRow, setSelectedRow] = useState("");

  const [mentorShipReqData, setMentorShipReqData] = useState();
  const [tableList, setTableList] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState();
  const history = useHistory();
  const [indexCounter, setIndexCounter] = useState(0);
  const [nameListValue, setNameListValue] = useState([]);
  const [filterName, setFilterName] = useState("");
  const [filterNameValue, setFilterNameValue] = useState("");

  const defaultFormData = {
    search: "",
    industry: null,
    specialization: null,
    stage: null,
    recognized: "",
    state: "",
    country: "",
  };

  const newCountryArray = [];
  const newStateArray = [];
  const [selectedStatus, setSelectedStatus] = useState("");

  const [formData, setFormData] = useState(defaultFormData);
  const [newCountryOptions, setNewCountryOptions] = useState(newCountryArray);
  const [newStateOptions, setNewStateOptions] = useState(newStateArray);
  const [newCountrySelect, setNewCountrySelect] = useState(false);
  const [allMentorNames, setAllMentorNames] = useState();
  const [filterIndustry, setFilterIndustry] = useState("");
  const [filterFunction, setFilterFunction] = useState("");
  const [filterStage, setFilterStage] = useState("");
  const [filterState, setFilterState] = useState("");
  const [filterCountry, setFilterCountry] = useState("");
  const [chatBoxModalOpen, setChatBoxModalOpen] = useState(false);
  const [mentorRequest, setMentorRequest] = useState();
  const [mentorRequestId, setMentorRequestId] = useState();
  const [maxTotalCount, setMaxTotalCount] = useState(0);
  const [nameListData, setNamesListData] = useState([]);
  const [data, setData] = useState();
  const [paginationData, setPaginationData] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [activeNow, setActiveNow] = useState("ACTIVE");
  const [nameListValue2, setNameListValue2] = useState([]);
  const [filterName2, setFilterName2] = useState("");
  const [filterNameValue2, setFilterNameValue2] = useState("");
  const [isShown, setIsShown] = useState(false);
  const setModalIsOpenToTrue = () => {
    setIsShown(!isShown);
  };
  const {
    startUpApplication,
    startUpApplicationPagineate,
    getCounterStartUp,
    getPredefineOptionsList,
    getPredefineOptions,
  } = props;
  const currentRoute = window.location.href;
  let sample;
  sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));

  useEffect(() => {
    html.style.overflow = "auto";

    let params = {
      listKey: "Mentor",
    };
    getNamesList(params);
  }, []);
  useEffect(() => {
    getTableFn();
  }, []);
  const getTableFn = () => {
    let params = {
      // status: "ActiveMentorships",
      status:
        history?.location?.state?.pageSection === "mentorshipScheduled"
          ? "NoSessions"
          : "AutoClosed",
      state: formData.state == "select" ? null : formData?.state?.value, // optional
      industry: formData.industry == "select" ? "" : formData?.industry?.value, // optional
      function: formData.function == "select" ? "" : formData?.function?.value, // optional
      stage: formData.stage == "select" ? "" : formData?.stage?.value,
      mentorId: formData?.name?.value === "Select" ? "" : formData.name?.value,
      startupId:
        formData?.startUpname?.value === "Select"
          ? ""
          : formData?.startUpname?.value,
      searchField: "",
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "",
        sortOrder: "DESC",
      },
    };
    getActivitySummaryMentorshipStatus(params);
  };
  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    let params = {
      status:
        history?.location?.state?.pageSection === "mentorshipScheduled"
          ? "NoSessions"
          : "AutoClosed",
      state: formData.state == "select" ? null : formData?.state?.value, // optional
      industry: formData.industry == "select" ? "" : formData?.industry?.value, // optional
      function: formData.function == "select" ? "" : formData?.function?.value, // optional
      stage: formData.stage == "select" ? "" : formData?.stage?.value,
      mentorId: formData?.name?.value === "Select" ? "" : formData.name?.value,
      startupId:
        formData?.startUpname?.value === "Select"
          ? ""
          : formData?.startUpname?.value,
      searchField: "",
      pageFilter: {
        currentPage: pageNumber - 1,
        includeCount: true,
        pageSize: 10,
        sortField: "",
        sortOrder: "DESC",
      },
    };
    getActivitySummaryMentorshipStatus(params);
  };
  useEffect(() => {
    let params = {
      status:
        history?.location?.state?.pageSection === "mentorshipScheduled"
          ? "NoSessions"
          : "AutoClosed",
      industry: "",
      function: "",
      state: "",
      mentorId: "",
      searchField: "",
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "",
        sortOrder: "DESC",
      },
    };
    getActivitySummaryMentorshipStatus(params);
  }, []);
  useEffect(() => {
    let nameArrList = [];

    if (
      getNamesListData &&
      getNamesListData[0]?.name !== "ASIANCOATINGS N PAINTS PRIVATE LIMITED"
    )
      getNamesListData?.forEach((element, index) => {
        if (index === 0) {
          let arr2 = {
            value: "Select",
            label: "Select Mentor",
          };
          setNameListValue((oldArray) => [...oldArray, arr2]);
        }
        let arr = {
          value: element.id,
          label: element.name,
        };
        if (nameListData?.length >= nameListValue?.length)
          setNameListValue((oldArray) => [...oldArray, arr]);
      });
  }, [getNamesListData]);
  useEffect(() => {
    // axios({
    //   url: GET_NAMES_DATA,
    //   method: "post",
    //   data: {
    //     listKey: "Startup",
    //   },
    // })
    api
      .POST(GET_NAMES_DATA, {
        listKey: "Startup",
      })
      .then((res) => {
        let getNamesListData = res.data?.data;
        getNamesListData?.forEach((element, index) => {
          if (index === 0) {
            let arr2 = {
              value: "Select",
              label: "Select Startup",
            };
            setNameListValue2((oldArray) => [...oldArray, arr2]);
          }
          let arr = {
            value: element.id,
            label: element.name,
          };
          if (nameListData?.length >= nameListValue?.length)
            setNameListValue2((oldArray) => [...oldArray, arr]);
        });
      })
      .catch((err) => {});
  }, []);
  const customStyles = {
    container: (provided) => ({
      ...provided,
      // width: 170,
      marginRight: 5,
      whiteSpace: "nowrap",
      textAlign: "left",
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isSelected
          ? "#b499c7"
          : isFocused
          ? "#e4d7ee"
          : "white",
        color: isSelected ? "white" : "black",
        cursor: isDisabled ? "not-allowed" : "default",
      };
    },
    menu: (base) => ({
      ...base,
      width: "max-content",
      minWidth: "100%",
      fontSize: "14px",
      whiteSpace: "nowrap",
      textAlign: "left",
    }),
  };
  const customStyles2 = {
    container: (provided) => ({
      ...provided,
      // width: 120,
      // width:120,
      // marginLeft:15,
      // marginRight:15
    }),
    option: (provided, state) => ({
      ...provided,

      textAlign: "left",
    }),
    menu: (base) => ({
      ...base,
      width: "max-content",
      minWidth: "100%",
      fontSize: "14px",
    }),
  };
  useEffect(() => {
    getPredefineOptionsList();
  }, []);

  const ViewApplication = (dpiitNo) => {
    let reRoute = window.open(sample + "/view-StartupApplication", "_blank");
    reRoute.id = dpiitNo;
    reRoute.fromModule = "startUpApplications";
  };
  const redirectProfile = (item, id) => {
    setSelectedRow(id);
    let reRoute = window.open(sample + `/startup-profile/${item}`, "_blank");
    reRoute.id = item;
  };
  const getStartUpId = (string) => {
    const value = string.substring(string?.length - 6);
    return value;
  };
  useEffect(() => {
    const indDefaultObject = {
      value: "select",
      label: "Select Country",
    };

    const indDefaultObject2 = {
      value: "select",
      label: "Select State",
    };

    Country.getAllCountries().map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newCountryArray.push(newObject);

      setNewCountryOptions(newCountryArray);
    });

    newCountryArray.unshift(indDefaultObject);

    State.getStatesOfCountry(newCountrySelect === true ? "IN" : null).map(
      (item) => {
        const newObject = {
          value: item.name,
          label: item.name,
        };

        newStateArray.push(newObject);

        setNewStateOptions(newStateArray);
      }
    );
    newStateArray.unshift(indDefaultObject2);
  }, [newCountrySelect]);
  const ViewProfile = (item, id) => {
    setSelectedRow(id);

    // let reRoute = window.open(sample + `/mentor-profile/${item}`, "_blank");
    let reRoute = window.open(sample + `/mentor-profile/${encryptAES2(item,PROFILE_KEY)}`, "_blank");
    reRoute.id = item;
  };
  useEffect(() => {
    window.scrollTo(0, 1);
  }, []);
  useEffect(() => {
    getStepperTooltipData();
  }, []);
  useEffect(() => {
    //
    //
    setHeading(getStepperData?.Guidedinstructions[0].Heading);
    setInstructionswithRole(
      getStepperData?.Guidedinstructions[0].InstructionswithRole
    );
    setSelectPage(getStepperData?.Guidedinstructions[0].SelectPage);
  }, [getStepperData]);
  const getExcelDownload = () => {
    let url = history?.location?.state?.pageSection === "mentorshipScheduled" ? DOWNLOAD_EXCEL_MENTORSHIP_NO_SESSION : DOWNLOAD_EXCEL_MENTORSHIP_NO_SESSION;
    let fileName = history?.location?.state?.pageSection === "mentorshipScheduled" ? 'MentorshipWithNoSession.xls' : 'MentorshipAutoClosed.xls';
    api
      .GET(`${url}`, {responseType: "blob",})
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${fileName}`);
        document.body.appendChild(link);
        link.click();
      });
  };
  return (
    <>
      <div className="mentorlistmaindiv mwntorthirdpage">
        <div className="dashboard-main2" style={{ background: "none" }}>
          <div
            className="dashboard-bottom-btn4 topbackbtnmentorlist"
            style={{ background: "transparent", border: "none" }}
          >
            <div className="newuserTooltip">
              <MaterialButton
                className="topbackbtnactual top-btn"
                variant="contained"
                color="primary"
                onClick={() => {
                  if (
                    history?.location?.state?.fromModule === "activitySummary"
                  ) {
                    localStorage.setItem("activitySummary", "activitySummary");

                    window.location.reload();
                  } else {
                    localStorage.setItem(
                      "mentorDashboardHome",
                      "mentorDashboardHome"
                    );

                    window.location.reload();
                  }
                }}
                style={{ background: "#3ac2d7" }}
              >
                {" "}
                Back
              </MaterialButton>
              <span
                className="tooltiptext tooltip-bottom"
                style={{
                  top: "69px",
                  width: "217px",
                  left: "71px",
                }}
              >
                Click to Go Activity Summary
              </span>
            </div>
            <Modal
              modalOpen={modalOpen}
              setModalOpen={setModalOpen}
              modalData={modalData}
            />
          </div>
          <div className="iconWith-heading iconheadingdata">
            <div style={{ width: "100%",marginLeft:"4rem",whiteSpace:"nowrap" }}>
              <h3
                className="sub-heading fadeInDown wow"
                style={{ color: "#262838", fontWeight: 600, fontSize: "28px" }}
              >
                MAARG Portal by Startup India
              </h3>
              <h3 className="dashboard-sub-heading fadeInDown wow">
                ACTIVITY SUMMARY:{" "}
                {history?.location?.state?.pageSection === "mentorshipScheduled"
                  ? "MENTORSHIPS WITH NO SESSIONS"
                  : "MENTORSHIPS AUTO CLOSED"}
              </h3>
            </div>
            {/* {
              history?.location?.state?.pageSection === "mentorshipScheduled" &&
              <a onClick={() => getExcelDownload()}>
              <div className="newuserTooltip">
                <img
                  className="excelButton excelbuttonadmindash"
                  src={excelButton}
                  style={{ top: "2.4rem", width: "65%", left: "1rem" }}
                ></img>
                <span
                  className="tooltiptext   tooltip-bottom admincohort01"
                  style={{ left: "0.5rem", top: "5.75rem", width: "12vw" }}
                >
                  Download Excel Report
                </span>
              </div>
            </a>
            } */}
          
            <div
              className="tooltipshow eyeIcon"
              // onClick={() => {
              //   // html.style.overflow = "hidden";

              //   if (html.style.overflow == "auto") {
              //     html.style.overflow = "hidden";
              //   } else {
              //     html.style.overflow = "auto";
              //   }
              // }}
            >
              <div className="newuserTooltip">
                <img
                  className="iconbtn top-btn"
                  src={iconTooltip}
                  onClick={() => {
                    setModalIsOpenToTrue();
                    if (html.style.overflow == "auto") {
                      html.style.overflow = "hidden";
                    } else {
                      html.style.overflow = "auto";
                    }
                  }}
                  width={60}
                />{" "}
                <span
                  className="tooltiptext tooltip-bottom "
                  style={{ width: "130px", top: "50px", left: "20px" }}
                >
                  View Instructions
                </span>
              </div>
            </div>
            {isShown && (
              <div>
                <AnimeList
                  setModalIsOpenToTrue={setModalIsOpenToTrue}
                  Heading={Heading}
                  InstructionswithRole={InstructionswithRole}
                  SelectPage={SelectPage}
                />
              </div>
            )}
          </div>
        </div>
        <div className="col-md-11 display-center mobilementorsummary">
          <div className="admin-bottom-card row">
            <div
              className="mentorImageParent d-flex justify-content-end"
              style={{
                background: "none",
                border: "0px",
                borderRadius: "0px",
              }}
            >
              <img src={mentorIcon} className="sidebar-dashboard-icon2" />
            </div>
            <div className="dashboard-bottom-btn3">
              <p className="text-white">MENTORSHIPS</p>
            </div>
            <div class="w-20 newuserTooltip circleBorder maxtotalCount">
              {history?.location?.state?.pageCounter !== undefined &&
                history?.location?.state?.pageCounter}
            </div>
            <div class="w-40 newuserTooltip activitySummaryText last15days">
              {history?.location?.state?.pageSection === "mentorshipScheduled"
                ? "Mentorships with no sessions scheduled"
                : "Mentorships auto closed"}
            </div>
          </div>

          <div className="filter-row filter-row-common filterDivMentorapp">
            {/* <div className="container"> */}
            <div>
              <form className="formContainer">
                <div className="row desktopFilterRow">
                  <div className="col-11 d-flex justify-content-between filterBoxRightAlign filterboxfixwidthformb2">
                    <div className="newuserTooltip dropDownWidthFix05">
                      <Select
                        required={true}
                        id="searchBy"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="searchBy"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.name}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              name: e.name == "select" ? null : e,
                            };
                          });
                          setFilterName(e.name);
                          // getSummaryListName(e.value);
                          //   setFilterNameValue(e.value);
                          //   getMentorListName(e.value);
                        }}
                        options={nameListValue.length > 0 ? nameListValue : ""}
                        placeholder="Search Mentor"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Mentor
                      </span>
                    </div>
                    <div className="newuserTooltip dropDownWidthFix05">
                      <Select
                        required={true}
                        id="searchBy"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="searchBy"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.startUpname}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              startUpname: e.name == "select" ? null : e,
                            };
                          });
                          setFilterName2(e.name);
                          // getSummaryListName(e.value);
                          //   setFilterNameValue(e.value);
                          //   getMentorListName(e.value);
                        }}
                        options={
                          nameListValue2.length > 0 ? nameListValue2 : ""
                        }
                        placeholder="Search Startup"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Startup
                      </span>
                    </div>
                    <div className="col-8 d-flex filterRemainingPosition">
                      <div className="user-type-dropdown  dropDownWidthFix5 newuserTooltip">
                        <Select
                          required={true}
                          id="Industry"
                          variant="outlined"
                          fullWidth
                          margin="normal"
                          name="industry"
                          className="col-12 gendermentorinput"
                          styles={customStyles2}
                          value={formData.industry}
                          onChange={(e) => {
                            setFormData((user) => {
                              return {
                                ...user,
                                industry: e.value == "select" ? null : e,
                              };
                            });
                            setFilterIndustry(e.value);
                          }}
                          options={getPredefineOptions?.industry_options}
                          placeholder="Industry"
                        />
                        <span
                          className="tooltiptext tooltip-bottom"
                          style={{ left: "77px", top: "45px", width: "130px" }}
                        >
                          Search Industry
                        </span>
                      </div>

                      <div className="user-type-dropdown  dropDownWidthFix5 newuserTooltip">
                        <Select
                          required={true}
                          id="specialization"
                          variant="outlined"
                          fullWidth
                          margin="normal"
                          name="specialization"
                          className="col-12 gendermentorinput"
                          styles={customStyles2}
                          value={formData.function}
                          onChange={(e) => {
                            setFormData((user) => {
                              return {
                                ...user,
                                function: e.value == "select" ? null : e,
                              };
                            });
                            setFilterFunction(e.value);
                          }}
                          options={getPredefineOptions?._specialisation}
                          placeholder="Function"
                        />
                        <span
                          className="tooltiptext tooltip-bottom"
                          style={{ left: "77px", top: "45px", width: "130px" }}
                        >
                          Search Function
                        </span>
                      </div>

                      <div className="user-type-dropdown  dropDownWidthFix5 newuserTooltip">
                        <Select
                          required={true}
                          id="stage"
                          variant="outlined"
                          fullWidth
                          margin="normal"
                          name="stage"
                          className="col-12 gendermentorinput"
                          styles={customStyles2}
                          value={formData.stage}
                          onChange={(e) => {
                            setFormData((user) => {
                              return {
                                ...user,
                                stage: e.value == "select" ? null : e,
                              };
                            });
                            setFilterStage(e.value);
                          }}
                          options={
                            getPredefineOptions?.stage_of_startup_options
                          }
                          placeholder="Stage"
                        />

                        <span
                          className="tooltiptext tooltip-bottom"
                          style={{ left: "77px", top: "45px", width: "130px" }}
                        >
                          Search Stage
                        </span>
                      </div>
                      <div className="user-type-dropdown  dropDownWidthFix5 newuserTooltip">
                        <Select
                          required={true}
                          id="country"
                          variant="outlined"
                          fullWidth
                          margin="normal"
                          name="country"
                          className="col-12 gendermentorinput"
                          styles={customStyles2}
                          value={formData.country}
                          onChange={(e) => {
                            setFormData((user) => {
                              return {
                                ...user,
                                country: e.value == "select" ? null : e,
                              };
                            });

                            setFilterCountry(e.label);

                            if (e.label === "India") {
                              setNewCountrySelect(true);
                              setFilterState("");
                            } else {
                              setNewCountrySelect(false);
                              setFilterState("");
                              setFormData((user) => {
                                return {
                                  ...user,
                                  state: "",
                                };
                              });
                            }
                            setNewStateOptions("");
                          }}
                          options={newCountryOptions}
                          placeholder="Country"
                        />
                        <span
                          className="tooltiptext tooltip-bottom"
                          style={{ left: "77px", top: "45px", width: "130px" }}
                        >
                          Search Country
                        </span>
                      </div>
                      <div className="user-type-dropdown  dropDownWidthFix5 newuserTooltip">
                        <Select
                          required={true}
                          id="state"
                          variant="outlined"
                          fullWidth
                          margin="normal"
                          name="state"
                          className="col-12 gendermentorinput"
                          styles={customStyles2}
                          value={formData.state}
                          onChange={(e) => {
                            setFormData((user) => {
                              return {
                                ...user,
                                state: e.value == "select" ? null : e,
                              };
                            });
                            setFilterState(e.value);
                          }}
                          options={newStateOptions}
                          placeholder="State"
                        />
                        <span
                          className="tooltiptext tooltip-bottom"
                          style={{ left: "77px", top: "45px", width: "130px" }}
                        >
                          Search State
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-1 goBtnDivPositionResponsive gotgobtntable5 newuserTooltip">
                    <Button
                      onClick={() => getTableFn()}
                      text="GO"
                      className="top-btn goBtnResponsive"
                    ></Button>
                    <span
                      className="tooltiptext   tooltip-bottom"
                      style={{
                        left: "46px",
                        width: "126px",
                        height: "48px",
                        top: "42px",
                      }}
                    >
                      Click to Apply Filters
                    </span>
                  </div>
                </div>

                <div className="row mobileFilterRow">
                  <div className="col-md-1 filter-text">Filter by</div>

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="Industry"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="industry"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.industry}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            industry: e.value == "select" ? null : e,
                          };
                        });
                        setFilterIndustry(e.value);
                      }}
                      options={getPredefineOptions?.industry_options}
                      placeholder="Industry"
                    />
                  </div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="specialization"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="specialization"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.function}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            function: e.value == "select" ? null : e,
                          };
                        });
                        setFilterFunction(e.value);
                      }}
                      options={getPredefineOptions?._specialisation}
                      placeholder="Function"
                    />
                  </div>

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="stage"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="stage"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.stage}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            stage: e.value == "select" ? null : e,
                          };
                        });
                        setFilterStage(e.value);
                      }}
                      options={getPredefineOptions?.stage_of_startup_options}
                      placeholder="Stage"
                    />
                  </div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="country"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="country"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.country}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            country: e.value == "select" ? null : e,
                          };
                        });

                        setFilterCountry(e.label);

                        if (e.label === "India") {
                          setNewCountrySelect(true);
                        } else {
                          setNewCountrySelect(false);
                          setFormData((user) => {
                            return {
                              ...user,
                              state: "",
                            };
                          });
                        }
                        setNewStateOptions("");
                      }}
                      options={newCountryOptions}
                      placeholder="Country"
                    />
                  </div>

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="state"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="state"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.state}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            state: e.value == "select" ? null : e,
                          };
                        });
                        setFilterState(e.value);
                      }}
                      options={newStateOptions}
                      placeholder="State"
                    />
                  </div>
                  <div
                    className="col-md-1 apply-section"
                    style={{ color: "transparent" }}
                  >
                    <Button
                      className="green-btn filter-btn"
                      //   onClick={() => getStartupApplicationTable(selectedStatus)}
                      text="Apply"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div className="totalTableCount">
            Total Records Found :{" "}
            {getTablePaginate && getTablePaginate?.totalElements} &lt;{" "}
            {getTablePaginate && getTablePaginate?.currentPage} of{" "}
            {getTablePaginate && getTablePaginate?.numPages} &gt;
          </div>
          {getTableData && getTableData?.length > 0 ? (
            <div>
              <div className="table-container mt-2">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th
                        style={{ verticalAlign: "middle", width: "3%" }}
                        className="fixColumbnWidth4"
                      >
                        {" "}
                        <div style={{ verticalAlign: "middle" }}>NO.</div>
                      </th>
                      <th
                        style={{ verticalAlign: "middle", width: "5%" }}
                        className="fixColumbnWidth"
                        // style={{ minWidth: "59.9rem", maxWidth: "60rem" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                          }}
                        >
                          MENTORSHIP ID
                        </div>
                      </th>
                      <th
                        // className="fixColumbnWidth7"
                        // style={{
                        //   minWidth: "9.9rem",
                        //   maxWidth: "10rem",
                        //   verticalAlign: "middle",
                        // }}
                        colspan="2"
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            height: "60px",

                            minWidth: "23.4rem",
                            maxWidth: "23.5rem",
                          }}
                        >
                          MENTOR
                        </div>
                      </th>
                      <th
                        // className="fixColumbnWidth7"
                        // style={{
                        //   minWidth: "9.9rem",
                        //   maxWidth: "10rem",
                        //   verticalAlign: "middle",
                        // }}
                        colspan="2"
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            height: "60px",

                            minWidth: "23.4rem",
                            maxWidth: "23.5rem",
                          }}
                        >
                          STARTUP
                        </div>
                      </th>
                      {/* <th
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            height: "60px",
                            paddingBottom: "1rem",
                          }}
                        >
                          MENTORSHIP REQUESTS DATE
                        </div>
                      </th> */}
                      {history?.location?.state?.pageSection ===
                      "mentorshipClosed" ? (
                        <>
                          <th>NO. OF SESSIONS</th>
                          <th>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "left",
                                alignItems: "center",
                                height: "60px",
                                paddingBottom: "0.5rem",
                              }}
                            >
                              MENTORSHIP AUTO CLOSED DATE
                            </div>
                          </th>
                        </>
                      ) : (
                        ""
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {getTableData.map((item, index) => (
                      <tr>
                        <td style={{ verticalAlign: "top" }}>
                          {index +
                            1 +
                            10 *
                              (getTablePaginate &&
                                getTablePaginate.currentPage - 1)}{" "}
                        </td>

                        <td className="togglediv">
                          {item.mentorRequest?.mentorshipId !== null &&
                          item.mentorRequest?.mentorshipId !== undefined ? (
                            <div className="d-flex">
                              <div>
                                {"M" +
                                  item.mentorRequest?.mentorshipId?.substring(
                                    item.mentorRequest?.mentorshipId?.length - 6
                                  )}
                              </div>
                              <div
                                className="d-flex newuserTooltip"
                                style={
                                  history?.location?.state?.pageSection ===
                                  "mentorshipClosed"
                                    ? {
                                        cursor: "pointer",
                                        justifyContent: "center",
                                        height: "50px",
                                        width: "40px",
                                        display: "flex",
                                        position: "relative",
                                        top: "7rem",
                                        left: "1rem",
                                      }
                                    : {
                                        cursor: "pointer",
                                        justifyContent: "center",
                                        height: "50px",
                                        width: "40px",
                                        display: "flex",
                                        position: "relative",
                                        top: "7rem",
                                        left: "0.25rem",
                                      }
                                }
                              >
                                <img
                                  src={mentorshipIcon2}
                                  alt={item.title}
                                  onClick={() => {
                                    window.open(
                                      `/mentor-dashboard/mentorships/engagement-summary/${item?.mentorRequest?.mentorshipId}`,
                                      "_blank"
                                    );
                                  }}
                                />
                                <span
                                  className="tooltiptext tooltip-bottom"
                                  style={{
                                    width: "140px",
                                    top: "53px",
                                    left: "10px",
                                    height: "50px",
                                  }}
                                >
                                  View Mentorship Engagement
                                </span>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </td>

                        <td className="togglediv2">
                          {item.mentorRequest?.mentorshipId !== null ? (
                            <div className="d-flex">
                              <div>
                                {"M" +
                                  item.mentorRequest?.mentorshipId?.substring(
                                    item.mentorRequest?.mentorshipId?.length - 6
                                  )}

                                <div
                                  style={
                                    history?.location?.state?.pageSection ===
                                    "mentorshipClosed"
                                      ? {
                                          cursor: "pointer",
                                          justifyContent: "center",

                                          width: "40px",
                                          display: "flex",
                                          position: "relative",

                                          left: "1rem",
                                        }
                                      : {
                                          cursor: "pointer",
                                          justifyContent: "center",

                                          width: "40px",
                                          display: "flex",
                                          position: "relative",

                                          left: "0.25rem",
                                        }
                                  }
                                >
                                  <img
                                    src={mentorshipIcon2}
                                    alt={item.title}
                                    onClick={() => {
                                      window.open(
                                        `/mentor-dashboard/mentorships/engagement-summary/${item?.mentorRequest?.mentorshipId}`,
                                        "_blank"
                                      );
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </td>

                        <td className="incrisingheightforcellphone55">
                          <div
                            className="newuserTooltip"
                            style={{
                              width: "100px",
                              height: "100px",
                              maxWidth: "none",
                              objectFit: "contain",
                            }}
                          >
                            <img
                              src={
                                item.mentor.image !== null &&
                                item.mentor.image !== ""
                                  ? item.mentor.image
                                  : hashImage
                              }
                              onClick={() =>
                                ViewProfile(
                                  item?.mentor?.email,
                                  item?.mentor?.id
                                )
                              }
                              // src={
                              //   "https://holmesbuilders.com/wp-content/uploads/2016/12/male-profile-image-placeholder.png"
                              // }
                              className="sidebar-dashboard-icon2 newWidthIconFIx"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                                cursor: "pointer",
                                // maxWidth: "none",
                                // objectFit: "contain",
                              }}
                            />
                            <span
                              className="tooltiptext tooltip-bottom "
                              style={{
                                left: "46px",
                                top: "94px",
                                width: "150px",
                              }}
                            >
                              View Mentor Profile
                            </span>
                            <div className="incrisingheightforcellphone02">
                              <p>{item?.mentor?.name}</p>
                              <p>
                                {" "}
                                {"M" +
                                  item?.mentor?.id?.substring(
                                    item?.mentor?.id?.length - 6
                                  )}
                              </p>
                              {/* <p>{item.mentor.organization_name}</p> */}
                              <p>
                                {" "}
                                {item?.mentor?.organization_name.length > 30 ? (
                                  <div className="tooltipicon">
                                    {item?.mentor?.organization_name.substring(
                                      0,
                                      30
                                    )}
                                    <svg
                                      style={{
                                        position: "relative",
                                        top: "0.1rem",
                                        cursor: "pointer",
                                      }}
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="20"
                                      fill="currentColor"
                                      class="bi bi-three-dots"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                                    </svg>
                                    <span className="tooltiptext7">
                                      <h5 style={{ color: "#fff" }}>
                                        Organization Name
                                      </h5>
                                      {item?.mentor?.organization_name}
                                    </span>
                                  </div>
                                ) : (
                                  item?.mentor?.organization_name
                                )}
                              </p>
                              {/* <p>{item.mentor.current_designation}</p> */}
                              <p>
                                {" "}
                                {item?.mentor?.current_designation.length >
                                20 ? (
                                  <div className="tooltipicon">
                                    {item?.mentor?.current_designation.substring(
                                      0,
                                      20
                                    )}
                                    <svg
                                      style={{
                                        position: "relative",
                                        top: "0.1rem",
                                        cursor: "pointer",
                                      }}
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="20"
                                      fill="currentColor"
                                      class="bi bi-three-dots"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                                    </svg>
                                    <span className="tooltiptext7">
                                      <h5 style={{ color: "#fff" }}>
                                        Designation Name
                                      </h5>
                                      {item?.mentor?.current_designation}
                                    </span>
                                  </div>
                                ) : (
                                  item?.mentor?.current_designation
                                )}
                              </p>
                              <p>{item.mentor.city}</p>
                              <div
                                className="d-flex justify-content-end "
                                style={{
                                  cursor: "pointer",
                                  alignItems: "end",
                                  justifyContent: "center",
                                  width: "40px",
                                  display: "flex",
                                  float: "right",
                                }}
                                onClick={() =>
                                  ViewProfile(
                                    item?.mentor.email,
                                    item?.mentor.id
                                  )
                                }
                              >
                                <img src={mentorMiniIcon} width={40} />
                              </div>
                            </div>
                          </div>
                        </td>
                        <td
                          className="specifivdix"
                          style={
                            history?.location?.state?.pageSection ===
                            "mentorshipScheduled"
                              ? { minWidth: "24.9rem", maxWidth: "25rem" }
                              : { minWidth: "13.9rem", maxWidth: "14rem" }
                          }
                        >
                          <div>{item?.mentor?.name}</div>
                          <div>
                            {"M" +
                              item?.mentor?.id?.substring(
                                item?.mentor?.id?.length - 6
                              )}
                          </div>
                          <div>{item.mentor.organization_name}</div>
                          <div>{item.mentor.current_designation}</div>
                          <div>{item.mentor.city}</div>
                          <div
                            className="d-flex justify-content-end newuserTooltip"
                            style={{
                              cursor: "pointer",
                              alignItems: "end",
                              justifyContent: "center",
                              width: "40px",
                              display: "flex",
                              float: "right",
                            }}
                            onClick={() =>
                              ViewProfile(item?.mentor.email, item?.mentor.id)
                            }
                          >
                            <img src={mentorMiniIcon} />
                            <span
                              className="tooltiptext tooltip-bottom"
                              style={{
                                left: "15px",
                                top: "45px",
                                width: "150px",
                              }}
                            >
                              View Mentor Profile
                            </span>
                          </div>
                        </td>

                        <td className="incresseheigtsendsec">
                          <div
                            className="newuserTooltip"
                            style={{
                              width: "100px",
                              height: "100px",
                              maxWidth: "none",
                              objectFit: "contain",
                            }}
                          >
                            <img
                              src={
                                item?.startup.logo !== null &&
                                item?.startup.logo !== ""
                                  ? item?.startup.logo
                                  : hashImage
                              }
                              onClick={() =>
                                redirectProfile(item?.startup?.dippNumber)
                              }
                              className="sidebar-dashboard-icon2 newWidthIconFIx"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                                cursor: "pointer",
                                // maxWidth: "none",
                                // objectFit: "contain",
                              }}
                            />
                            <span
                              className="tooltiptext tooltip-bottom "
                              style={{
                                left: "46px",
                                top: "94px",
                                width: "150px",
                              }}
                            >
                              View Startup Profile
                            </span>
                            <div className="incresseheigtsendsec02">
                              {/* <p>{item?.startup?.organization_name}</p>  */}
                              <p>
                                {" "}
                                {item?.startup?.organization_name.length >
                                38 ? (
                                  <div className="tooltipicon">
                                    {item?.startup?.organization_name.substring(
                                      0,
                                      38
                                    )}
                                    <svg
                                      style={{
                                        position: "relative",
                                        top: "0.1rem",
                                        cursor: "pointer",
                                      }}
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="20"
                                      fill="currentColor"
                                      class="bi bi-three-dots"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                                    </svg>
                                    <span className="tooltiptext7">
                                      <h5 style={{ color: "#fff" }}>
                                        Organization Name
                                      </h5>
                                      {item?.startup?.organization_name}
                                    </span>
                                  </div>
                                ) : (
                                  item?.startup?.organization_name
                                )}
                              </p>
                              <p>{item?.startup?.dippNumber}</p>
                              <div
                                className="d-flex justify-content-end "
                                style={{
                                  cursor: "pointer",
                                  alignItems: "end",
                                  justifyContent: "center",
                                  width: "40px",
                                  display: "flex",
                                  float: "right",
                                }}
                                onClick={() =>
                                  redirectProfile(item?.startup?.dippNumber)
                                }
                              >
                                <img src={mentorMiniIcon} width={40} />
                              </div>
                            </div>
                          </div>
                        </td>
                        <td
                          className="specifivdix"
                          style={
                            history?.location?.state?.pageSection ===
                            "mentorshipScheduled"
                              ? {
                                  minWidth: "24.9rem",
                                  maxWidth: "25rem",
                                  position: "relative",
                                }
                              : {
                                  minWidth: "13.9rem",
                                  maxWidth: "14rem",
                                  position: "relative",
                                }
                          }
                        >
                          <div>{item?.startup?.organization_name}</div>
                          {/* <div>
                            {item?.startup?.id?.substring(
                              item?.startup?.id?.length - 6
                            )}
                          </div> */}
                          <div>{item?.startup?.dippNumber}</div>

                          {/* <div className="newuserTooltip">
                            <a
                              style={{ width: "fit-content" }}
                              onClick={() => {
                                setIndexCounter(item?.startup?.id);
                                ViewApplication(item?.startup?.dippNumber);
                              }}
                              className="color-green"
                            >
                              {item?.startup?.dippNumber}
                              <span
                                className="tooltiptext tooltip-bottom"
                                style={{ width: "12vw" }}
                              >
                                View Startup Application
                              </span>
                            </a>
                          </div> */}
                          <div
                            className="newuserTooltip"
                            style={{
                              cursor: "pointer",
                              position: "absolute",
                              padding: "12px",
                              right: "0px",
                              bottom: "0px",
                            }}
                            onClick={() =>
                              redirectProfile(item?.startup?.dippNumber)
                            }
                          >
                            <img src={mentorMiniIcon} height={40} width={40} />
                            <span
                              className="tooltiptext tooltip-bottom"
                              style={{
                                left: "26px",
                                top: "60px",
                                width: "150px",
                              }}
                            >
                              View Startup Profile
                            </span>
                          </div>
                        </td>
                        {/* <td style={{ verticalAlign: "top" }}>
                          <div>
                            {moment(item.startDate).format("DD/MM/YYYY")}
                          </div>
                          <div>{moment(item.startDate).format("hh:mm a")}</div>
                        </td> */}
                        {history?.location?.state?.pageSection ===
                        "mentorshipClosed" ? (
                          <>
                            <td style={{ verticalAlign: "top" }}>
                              {item.sessionScheduled}
                            </td>
                            <td style={{ verticalAlign: "top" }}>
                              <div>
                                {moment(item.startDate).format("DD/MM/YYYY")}
                              </div>
                            </td>
                          </>
                        ) : (
                          ""
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="pagination-box">
                  <Pagination
                    activePage={activePage}
                    itemsCountPerPage={10}
                    totalItemsCount={
                      getTablePaginate && getTablePaginate?.totalElements
                    }
                    pageRangeDisplayed={5}
                    onChange={handlePageChange.bind(this)}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="no-records">No Records Found</div>
          )}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    startUpApplication: state.StartUpReducer.StartUpApplications.data,
    startUpApplicationPagineate:
      state.StartUpReducer.StartUpApplications.paginate,
    getCounterStartUp: state.StartUpReducer.getCountersStartUpList.data,
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    getNamesListData: state.AdminMentorReducer.getNamesList?.data,
    getTableData:
      state.AdminMentorReducer.getActivitySummaryMentorshipStatus.data,
    getTablePaginate:
      state.AdminMentorReducer.getActivitySummaryMentorshipStatus.paginate,
    getStepperData: state.AdminMentorReducer.getStepperList.list,
  };
};
export default connect(mapStateToProps, {
  //   getStartupApplication,
  //   getCountersStartUpList,
  getActivitySummaryMentorshipStatus,
  getActivitySummaryPerformance,
  getPredefineOptionsList,
  getNamesList,
  getStepperTooltipData,
})(withRouter(MentorshipClosed));
